import { takeLatest, call, put } from "redux-saga/effects";
import {
  SUBMIT_COMPETITOR_PROFILE_V4_REQUEST,
  submitCompetitorProfileV4Success,
  submitCompetitorProfileV4Failure,
} from "../actions/competitorProfileV4Actions";
import { fetchCompetitorProfileV4 } from "../../../services/accIqService";

// Worker Saga
function* handleCompetitorProfileV4Submission(action) {
  try {
    const response = yield call(
      fetchCompetitorProfileV4,
      action.payload.dimension,
      action.payload.client,
      action.payload.company
    );
    yield put(submitCompetitorProfileV4Success(response));
  } catch (error) {
    yield put(
      submitCompetitorProfileV4Failure(error?.message || "Something went wrong")
    );
  }
}

// Watcher Saga
export function* watchCompetitorProfileV4Submission() {
  yield takeLatest(
    SUBMIT_COMPETITOR_PROFILE_V4_REQUEST,
    handleCompetitorProfileV4Submission
  );
}
